var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaterials(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7 37.85v-8.2l6.6 4.1ZM26 18.75q-2.3 0-3.9-1.6t-1.6-3.9q0-2.3 1.6-3.9t3.9-1.6h2v2h-2q-1.45 0-2.475 1.025Q22.5 11.8 22.5 13.25q0 1.45 1.025 2.475Q24.55 16.75 26 16.75h2v2Zm6 0v-2h2q1.45 0 2.475-1.025Q37.5 14.7 37.5 13.25q0-1.45-1.025-2.475Q35.45 9.75 34 9.75h-2v-2h2q2.3 0 3.9 1.6t1.6 3.9q0 2.3-1.6 3.9t-3.9 1.6Zm-5.5-4.5v-2h7v2Zm6.15 13.25v-4H43V5H17v18.5h-3V5q0-1.25.875-2.125T17 2h26q1.25 0 2.125.875T46 5v19.5q0 1.25-.875 2.125T43 27.5ZM5 46q-1.25 0-2.125-.875T2 43V24.5q0-1.25.875-2.125T5 21.5h26q1.25 0 2.125.875T34 24.5V43q0 1.25-.875 2.125T31 46Zm0-3h26V24.5H5V43Zm25-28.75Zm-12 19.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterials);
export default __webpack_public_path__ + "static/media/materials.3e5ef8ae7cdd8a248858c451a4c642c9.svg";
export { ForwardRef as ReactComponent };